/**
 * @generated SignedSource<<cf977740337b2d2e5e077e19c50ade60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeAroundSecondaryContentItemContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "homeAroundSecondaryContentItemContent";
};
export type homeAroundSecondaryContentItemContent$key = {
  readonly " $data"?: homeAroundSecondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeAroundSecondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeAroundSecondaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "bfc4b9b76c7e0e497ea26422c56ca98e";

export default node;
